import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomer, removeCustomer } from 'slice/customerSlice';
import AdminTable from 'common/AdminTable';

const ListUser = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.customer);

  const tableHeaders = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Mobile', accessor: 'mobile' },
    { Header: 'Address', accessor: 'address' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn removebtn mx-2" onClick={() => dispatch(removeCustomer(row.original.id))}>
            Remove
          </button>
        </>
      )
    }
  ];

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">User List</h4>
      </div>

      {loading && <p className="text-white">Loading...</p>}
      {error && <p className="text-danger">{error}</p>}
      {!loading && data?.length > 0 && <AdminTable tableHeaders={tableHeaders} tableData={data} />}
    </div>
  );
};

export default ListUser;
